const INITIAL_STATE = {
  data: {},
  errors: {},
}

const getReasons = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_REASON_LIST':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_REASON_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default getReasons;